import { createSelector } from "reselect";

const selectSlice = (state) => state.ClientStats || {};

export const selectClientStats = createSelector(selectSlice, (s) => s.data);
export const selectClientStatsLoading = createSelector(selectSlice, (s) => s.loading || false);
